import * as React from "react";
import { FormComponent } from "../../../../../react-core/Html/FormComponent";
import { PensionTransfer } from "../../Resources/TransferInstructionQuery";
import { WizardLabel, errorStepOne } from "../../Resources/Content";
import { PercentageTextBoxEditor } from "../../../../../react-core/Html/PercentageTextBoxEditor";
import { MoneyTextBoxEditor } from "../../../../../react-core/Html/Money/MoneyTextBoxEditor";
import { CurrencyCode } from "../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { NumberTextBoxEditor } from "../../../../../react-core/Html/NumberTextBoxEditor";
import { CommonHelper } from "../../../../../react-core/Helpers/CommonHelper";

interface IPensionDetailProps extends React.Props<PensionDetail> {
    onChange: (key: string, value: any) => void;
    data: PensionTransfer;
    onRef: (ref) => void;
}

export class PensionDetail extends FormComponent<IPensionDetailProps, {}> {
    constructor(props: any) {
        super(props);
        this.state = {
            isShowPopup: false,
        };
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    private onChange(key: string, value: any) {
        const data = this.props.data;
        data[key] = value;
        this.props.onChange("PensionTransferDetail", data);
    }

    private renderRow(title: string, component: React.Component | JSX.Element, index: number): JSX.Element {
        return (
            <div
                className="row"
                key={`pension-${index}`}
                style={{ backgroundColor: index % 2 == 1 ? "#eef8fa" : null, padding: "5px 0 " }}
            >
                <div className="col-12 col-sm-8">{title}</div>
                <div className="col-12 col-sm-4">{component}</div>
            </div>
        );
    }

    private renderRadio(data: boolean, key: string, onChange?: (val) => void): JSX.Element {
        return (
            <fieldset className="radio-layout-inline">
                <div className="controls-wrap">
                    <label className="radio-button pin-radio">
                        <input
                            type="radio"
                            name={key}
                            value="yes"
                            checked={data ? true : false}
                            onClick={() => {
                                if (onChange) {onChange(true);}
                                this.onChange(key, true);
                            }}
                        />
                        <span className="gfx" aria-hidden="true" />
                        <span className="label">Yes</span>
                    </label>
                    <label className="radio-button pin-radio">
                        <input
                            type="radio"
                            name={key}
                            value="no"
                            checked={data ? false : true}
                            onClick={() => {
                                if (onChange) {onChange(false);}
                                this.onChange(key, false);
                            }}
                        />
                        <span className="gfx" aria-hidden="true" />
                        <span className="label">No</span>
                    </label>
                </div>
            </fieldset>
        );
    }

    render() {
        const { data } = this.props;
        const config = [
            {
                title: WizardLabel.pensionDetail.Q1,
                component: (
                    <PercentageTextBoxEditor
                        isNotForm={true}
                        validationRules={[
                            {
                                errorMessage: errorStepOne.required,
                                validator: (v) => {
                                    return v !== null && v !== undefined ? true : false;
                                },
                            },
                        ]}
                        atMost={{
                            errorMessage: errorStepOne.atMost + "1000",
                            value: 1000,
                        }}
                        atLeast={{
                            errorMessage: errorStepOne.atLeast + "0",
                            value: 0,
                        }}
                        value={data.CumlativeTotal}
                        onChange={(v) => {
                            this.onChange("CumlativeTotal", v);
                        }}
                        onBlur={(v) => {
                            this.onChange("CumlativeTotal", Number(CommonHelper.downFixed(v, 2)));
                        }}
                    />
                ),
            },
            {
                title: WizardLabel.pensionDetail.Q2,
                component: this.renderRadio(data.IsErarmarkingOrAttachmentOrder, "IsErarmarkingOrAttachmentOrder"),
            },
            {
                title: WizardLabel.pensionDetail.Q3,
                component: this.renderRadio(data.IsBlockTransfer, "IsBlockTransfer"),
            },
            {
                title: WizardLabel.pensionDetail.Q4,
                component: this.renderRadio(data.TaxFreeLumpSum, "TaxFreeLumpSum", (val) => {
                    if (val == false) {
                        this.onChange("ProtectedAmount", null);
                        this.onChange("FundValue", null);
                    }
                }),
            },
            {
                title: WizardLabel.pensionDetail.Q5,
                component: (
                    <MoneyTextBoxEditor
                        isNotForm={true}
                        value={data.ProtectedAmount}
                        onChange={(v) => {
                            this.onChange("ProtectedAmount", v);
                        }}
                        validationRules={[
                            {
                                errorMessage: errorStepOne.required,
                                validator: (v) => {
                                    return data.TaxFreeLumpSum == false
                                        ? true
                                        : v !== null && v !== undefined
                                        ? true
                                        : false;
                                },
                            },
                        ]}
                        alwaysValidateOnUpdate={true}
                        disabled={data.TaxFreeLumpSum == false}
                        currency={CurrencyCode.GBP}
                    />
                ),
            },
            {
                title: WizardLabel.pensionDetail.Q6,
                component: (
                    <MoneyTextBoxEditor
                        isNotForm={true}
                        value={data.FundValue}
                        onChange={(v) => {
                            this.onChange("FundValue", v);
                        }}
                        validationRules={[
                            {
                                errorMessage: errorStepOne.required,
                                validator: (v) => {
                                    return data.TaxFreeLumpSum == false
                                        ? true
                                        : v !== null && v !== undefined
                                        ? true
                                        : false;
                                },
                            },
                        ]}
                        alwaysValidateOnUpdate={true}
                        disabled={data.TaxFreeLumpSum == false}
                        currency={CurrencyCode.GBP}
                    />
                ),
            },
            {
                title: WizardLabel.pensionDetail.Q7,
                component: this.renderRadio(data.HasTransferArrangementRight, "HasTransferArrangementRight", (val) => {
                    if (val == false) {this.onChange("ApplyAge", null);}
                }),
            },
            {
                title: WizardLabel.pensionDetail.Q8,
                component: (
                    <NumberTextBoxEditor
                        isNotForm={true}
                        value={data.ApplyAge}
                        validationRules={[
                            {
                                errorMessage: errorStepOne.required,
                                validator: (v) => {
                                    return data.HasTransferArrangementRight == false
                                        ? true
                                        : v !== null && v !== undefined
                                        ? true
                                        : false;
                                },
                            },
                        ]}
                        atMost={{
                            errorMessage: errorStepOne.atMost + "120",
                            value: 120,
                        }}
                        atLeast={{
                            errorMessage: errorStepOne.atLeast + "0",
                            value: 0,
                        }}
                        disabled={data.HasTransferArrangementRight == false}
                        alwaysValidateOnUpdate={true}
                        onChange={(v) => {
                            this.onChange("ApplyAge", v);
                        }}
                        onBlur={(v) => {
                            this.onChange("ApplyAge", Number(CommonHelper.downFixed(v, 0)));
                        }}
                    />
                ),
            },
        ];

        return (
            <>
                {config.map((ele, index) => {
                    return this.renderRow(ele.title, ele.component, index);
                })}
            </>
        );
    }
}
